<template>
    <div class="flex items-center gap-2 text-gray-600">
        <Icon
            v-if="iconName"
            :name="iconName"
            :class="iconClass"
        />
        <div class="font-semibold">
            {{ title }}
        </div>
    </div>
</template>

<script setup lang="ts">
    import { useSlots } from 'vue'
    import Icon from '@/Shared/Component/Icon.vue'

    const props = defineProps({
        title: {
            type: String,
            default: null,
        },
        iconName: {
            type: String,
            default: null,
        },
        iconClass: {
            type: String,
            default: 'w-4 h-4 text-gray-600',
        },
    })

    const slots: any = useSlots()
</script>
